import * as api from "../api";
import axios from "axios";
let base = api.BaseApiUrl;

//轮播图列表
export const carouseList = (params) => {
  return axios.get(`${base}/api/CarouselImage/GetCarouselImageList`, {
    params,
  });
};

//删除轮播图
export const deleteCarouse = (params) => {
    return axios.delete(`${base}/api/CarouselImage/DeleteCarouselImage`, { params: params });
}
//添加轮播图
export const addCarouse =(data)=>{
    return axios.post(`${base}/api/CarouselImage/PostAddCarouselImage`,data);
}
//修改轮播图
export const updateCarouse = (data) => {
    return axios.post(`${base}/api/CarouselImage/PostUpdateCarouselImage`, data);
}

